
export default [
    {
        path: "/errorPage/:errorName",
        name: "error_page",
        props: true,
        component: () => import(/* webpackChunkName: "error_page" */ "../views/ErrorPage.vue"),
        meta: { requiresAuth: true }
    },
    {
        path: "*",
        name: "not_found",
        component: () => import(/* webpackChunkName: "not_found" */ "../views/NotFound.vue")
    }
]